<script>
// Um dos quatro passos da boas-vindas, na grade 2x2 (redesenho de 18/09/2026).
//
// ★ Burro de propósito: recebe o passo JÁ REPARTIDO por `estrutura-do-roteiro.js` e só
// pinta. Repartir é decisão de layout e é REVERSÍVEL — o roteiro (`roteiro.js`) é o texto
// do owner, e é ele, inteiro, que a síntese lê.
//
// ⚠️ A CASCA do cartão (superfície, raio, padding) e o realce da legenda ficam no PAI: é
// o pai que sabe qual bloco o áudio está falando agora.
export default {
  name: 'BoasVindasPasso',
  props: {
    // `{ numero, titulo, descricao }` — ver `repartirPasso`.
    passo: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="boas-vindas-passo">
    <!-- ★ O número é `--primary` (token white-label, nunca um hex): ele ORDENA, e quem
         carrega a informação é o título logo abaixo. Num escritório de marca clara ele
         perde contraste sem custo funcional — por isso a cor da marca fica aqui e no
         marcador das linhas do rodapé, nunca no texto. -->
    <!-- ⚠️ `align-baseline`, nunca `align-center`: o número tem 24px e o título 14px, e
         centralizados pela caixa o número "flutua" em relação ao texto. Pela baseline os
         dois assentam na MESMA linha de escrita, que é o que o olho lê como alinhado.
         ★ E com título de duas linhas (o passo 4 é o mais longo) o número fica na
         PRIMEIRA delas: a baseline de um item de flex em bloco é a da sua primeira linha,
         então ele não estica nem centraliza no bloco inteiro. -->
    <div class="boas-vindas-passo__cabecalho d-flex align-baseline az-gap-small">
      <span class="boas-vindas-passo__numero ia-texto-titulo-cartao">{{ passo.numero }}</span>
      <!-- ⚠️ `mb-0` nos dois `<p>`: o Vuetify dá 16px de `margin-bottom` a TODO `<p>`
           (reset em `vuetify.css`), e era daí que vinha a faixa vazia embaixo da
           descrição — não do padding do cartão. -->
      <p class="boas-vindas-passo__titulo az-text-primary az-size-14 font-bold mb-0">
        {{ passo.titulo }}
      </p>
    </div>
    <p class="boas-vindas-passo__descricao az-ds-aux mt-1 mb-0">{{ passo.descricao }}</p>
  </div>
</template>

<style lang="sass" scoped>
.boas-vindas-passo
  &__numero
    color: var(--primary)
    // Não encolhe: com título de duas linhas o `<p>` ao lado é quem cede largura.
    flex: 0 0 auto

  &__descricao
    line-height: 1.5

    // O roteiro reparte em "Título: descrição", e a descrição começa na minúscula que a
    // fonte tem. A maiúscula é do CSS de propósito: o TEXTO fica intacto, e é ele que a
    // síntese lê.
    &::first-letter
      text-transform: uppercase
</style>
